import classnames from "classnames";
import { ErrorMessage } from "formik";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { MdErrorOutline } from "react-icons/md";

dayjs.extend(customParseFormat);
const dateFormat = "YYYY-MM-DD";

/* eslint-disable react/prop-types */
const DateInput = ({
  title,
  name,
  placeholder,
  requiredField,
  errors,
  setFieldValue,
  values,
  touched,
  setFieldTouched,
  disabledDate = false,
  defaultValue = false,
}) => {
  return (
    <div className="mb-4 w-full">
      <label
        htmlFor={name}
        className="block leading-6 text-gray-500 mb-2 text-sm"
      >
        {title}
        {requiredField && <span className="text-red-800 mx-1">*</span>}
      </label>
      <div>
        <DatePicker
          id={name}
          name={name}
          defaultPickerValue={defaultValue && dayjs(defaultValue, dateFormat)}
          type="date"
          placeholder={placeholder}
          value={values[name] && dayjs(values[name])}
          onChange={async (e) => {
            if (e) {
              await setFieldValue(
                name,
                `${e.$y}-${e.$M < 9 ? "0" + (e.$M + 1) : e.$M + 1}-${e.$D}`
              );
              if (!values[name]) {
                setFieldTouched(name, true, true);
              }
            }
          }}
          format={dateFormat}
          className={classnames(
            "h-[36px] block w-full rounded-md border-0 py-[6px] text-gray-500 ring-1 ring-inset  placeholder:text-gray-400 placeholder:font-light focus:ring-inset  sm:text-sm sm:leading-6",
            errors && errors[name] && touched && touched[name]
              ? "ring-red-600 focus:ring-red-600 text-red-600"
              : "ring-gray-200/10 focus:ring-primary-dark"
          )}
          disabledDate={disabledDate}
        />
      </div>

      <ErrorMessage name={name}>
        {(msg) => (
          <div className="text-xs text-red-500 text-left w-full flex gap-1 items-center mt-1">
            <MdErrorOutline size={16} />
            <p className="text-xs">{msg}</p>
          </div>
        )}
      </ErrorMessage>
    </div>
  );
};

export default DateInput;
